import { recommendationsInit } from '../cart/recommendations';

/**
 * Init the cart drawer
 * @param  {Object} item [ The added item to the cart ]
 * @return {Void}
 */
export const drawerInit = (item) => {
  const $drawer = $('.js-cart-drawer');
  const $drawerItemsHolder = $('.js-cart-drawer-items');

  $.ajax({
    url: `/products/${item.handle}?view=line-item&variant=${item.id}`,
    type: 'GET',
    dataType: 'html',
    success(res) {
      $drawerItemsHolder.empty().append($(res));
      $drawer.addClass('is-active');
      $('html').addClass('no-scroll');
      recommendationsInit(item.product_id, $('.js-cart-drawer .js-section-related-products'), $('.js-cart-drawer .js-products-holder'), 'product-item-card--small');
    },
  });
};
